import React from "react";
import { Link } from "react-router-dom";

const BrandInfo = ({
  title = "No brands yet",
  ctaHref = "/brand/new/",
  ctaLabel = "Create your first brand",
  showCta = true,
}) => {
  return (
    <div className="rounded-xl border border-theme-secondary bg-theme-secondary px-6 py-14 sm:px-10 sm:py-16 text-center max-w-2xl mx-auto">
      <h2 className="text-2xl sm:text-3xl font-semibold text-theme-text mb-4">
        {title}
      </h2>
      <p className="text-theme-text opacity-80 text-base leading-relaxed mb-8">
        A brand is your saved company/creator profile in MoonScroll. We'll use
        it to generate high-performing scripts/videos that stay on message.
      </p>
      <ul className="text-left max-w-md mx-auto space-y-4 mb-10">
        <li className="flex items-start gap-3">
          <span className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-lg border border-theme-secondary bg-theme-main text-theme-primary">
            <svg
              className="h-5 w-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              aria-hidden
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z"
              />
            </svg>
          </span>
          <div>
            <p className="text-sm font-medium text-theme-text">Profile</p>
            <p className="text-sm text-theme-text opacity-60 leading-snug">
              Capture goals ,voice, and positioning so every output feels like
              your brand.
            </p>
          </div>
        </li>
        <li className="flex items-start gap-3">
          <span className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-lg border border-theme-secondary bg-theme-main text-theme-primary">
            <svg
              className="h-5 w-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              aria-hidden
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"
              />
            </svg>
          </span>
          <div>
            <p className="text-sm font-medium text-theme-text">Overview</p>
            <p className="text-sm text-theme-text opacity-60 leading-snug">
              See a snapshot of the brand, audience fit, and toggle how hard you
              want to lean into promotion.
            </p>
          </div>
        </li>
        <li className="flex items-start gap-3">
          <span className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-lg border border-theme-secondary bg-theme-main text-theme-primary">
            <svg
              className="h-5 w-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              aria-hidden
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M9.813 15.904L9 18.75l-.813-2.846a4.5 4.5 0 00-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 003.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 003.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 00-3.09 3.09zM18.259 8.715L18 9.75l-.259-1.035a3.375 3.375 0 00-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 002.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 002.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 00-2.456 2.456zM16.894 20.567L16.5 21.75l-.394-1.183a2.25 2.25 0 00-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 001.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 001.423 1.423l1.183.394-1.183.394a2.25 2.25 0 00-1.423 1.423z"
              />
            </svg>
          </span>
          <div>
            <p className="text-sm font-medium text-theme-text">Ideas</p>
            <p className="text-sm text-theme-text opacity-60 leading-snug">
              Generate video concepts aligned with your brand and what you want
              to say next.
            </p>
          </div>
        </li>
        <li className="flex items-start gap-3">
          <span className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-lg border border-theme-secondary bg-theme-main text-theme-primary">
            <svg
              className="h-5 w-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              aria-hidden
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z"
              />
            </svg>
          </span>
          <div>
            <p className="text-sm font-medium text-theme-text">
              Scripts and videos
            </p>
            <p className="text-sm text-theme-text opacity-60 leading-snug">
              Turn ideas into scripts and explore video directions that fit your
              tone and are built to perform.
            </p>
          </div>
        </li>
      </ul>
      {showCta ? (
        <Link
          to={ctaHref}
          className="inline-flex items-center justify-center px-8 py-3.5 text-base font-medium rounded-lg bg-theme-primary text-theme-button hover:opacity-90 transition-opacity"
        >
          {ctaLabel}
        </Link>
      ) : null}
    </div>
  );
};

export default BrandInfo;
